import { sagaEffects, api, runSagas, config, qs } from '../dependencies';

import * as actions from './actions';
import actionTypes from './actionTypes';

function* handleRequestMenus({ payload }) {
    try {
        const { ids, date } = payload;

        if (ids.length > 0) {
            const query = qs.stringify({
                filter: {
                    where: {
                        restaurantId: {
                            inq: ids,
                        },
                        date: date.format('YYYY-MM-DD'),
                    },
                },
            });
            const response = yield api.get(`${config.api.menus}/?${query}`);
            const menus = response.data;

            yield sagaEffects.put(actions.setMenus(menus));
        }
    } catch (e) {
        // TODO: handle errors
    }
}

const handlers = {
    [actionTypes.REQUEST_MENUS]: handleRequestMenus,
};

export default function*() {
    yield sagaEffects.all([runSagas(handlers)]);
}
